import { useCart } from './cart';
import { useIsMainSubscribed } from './user';

export const useDocumentState = (requiresSubscription, id) => {
  const { miniCart, ownedProducts } = useCart();
  const isSubscribed = useIsMainSubscribed();

  let documentState = 'Buy';

  if (miniCart.has(id)) {
    documentState = 'in cart';
  }

  if (ownedProducts.has(id)) {
    documentState = 'Purchased';
  }

  if (requiresSubscription && isSubscribed && !ownedProducts.has(id)) {
    documentState = 'Open';
  }

  return documentState;
};

export default useDocumentState;
